import styled from 'styled-components';
import { StyledUiContainerProps } from 'components';

export const ViewContainer = styled.div<StyledUiContainerProps>`
  gap: 1em;
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: auto;
  grid-template-columns: 1fr;

  .machines-in-the-line-widget {
    grid-column-start: span 1;
  }

  .line-status-widget {
    grid-column-start: span 1;
  }

  .machines-table-widget {
    grid-column-start: span 1;
  }

  .visual-overview-widget {
    grid-column-start: span 1;
  }

  @media (max-width: 1350px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 950px) {
    display: flex;
    flex-direction: column;
    grid-gap: 1em;
  }
`;

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 1rem 0;
  gap: 1rem;
`;

export const SiteViewBorder = styled.div<StyledUiContainerProps>`
  border: 1px solid #c8c8c8;
  padding: 15px;
  border-radius: 8px;
  height: 100vh;
`;
